import React from "react";
import ModalWrapper from "../../components/atoms/formFields/wrapperModal/modalWrapper";
import BottomComboButtons from "../../components/atoms/formFields/buttons/bottomComboButtons";

const ConditionsModal = ({setTerms}) => {
  return (
    <>
      <ModalWrapper name="GENERAL TERMS & CONDITIONS" id="termsAndConditions" extraClasses="modal-dialog-scrollable custom-modal-size">
        <div className="Conditions">
          {/* <h3 className="tab-title" style={{ "textAlign": "justify" }}>GENERAL TERMS &amp; CONDITIONS</h3> */}
          <p style={{ "textAlign": "justify" }}>
            Please read the following General Terms and Conditions (
            <strong>"T&amp;C"</strong>) carefully as the provisions contained
            herein shall govern your access and use of our application and
            website &ldquo;Apni Kheti&rdquo; hereinafter referred to as&nbsp;
            <strong>Application</strong>. This Application is owned by or on
            behalf of&nbsp;<strong>Cogneesol AgTech Pvt Ltd,</strong>
            &nbsp;having its registered office at&nbsp;
            <strong>
              D-253, Sector-75, Industrial Area, Mohali (SAS Nagar).
            </strong>
            &nbsp;Our Application provides a platform for farmers in particular
            and rural people in general to get their issues and problems
            relating to agriculture, dairy farming, livestock and other related
            issues addressed from the experts affiliated to the field of
            agriculture. They can leave their questions in the form of writing,
            audio messages and video messages. Our Application would also
            provide a platform for the experts to provide expert advice, post
            comments, and publish articles and blogs related to agriculture and
            other diversified fields of agriculture. Further, this Application
            would also provide the facility to buy and sell the goods/Products
            and all these collectively hereinafter refer to as&nbsp;
            <strong>"the Services"</strong>&nbsp;and any additional services
            introduced by us and contained within constitutes acceptance by you
            of these Terms and Conditions.
          </p>
          <p style={{ "textAlign": "justify" }}>
            By downloading or otherwise accessing the Application you hereby
            agree to be bound by the following general terms and conditions and
            privacy policy. There may be the addition of additional features in
            the Application and those special features may have its own terms
            and conditions and those additional terms and conditions would also
            apply in context of use of an Application along with the Terms and
            Conditions.
          </p>
          <ul className="decimal-ul" style={{ "textAlign": "justify" }}>
            <li>
              <h3 className="small_title">GENERAL</h3>
              <ul className="decimal-ul">
                <ul className="decimal-ul">
                  <li>
                    The Application is owned and operated by&nbsp;
                    <strong>Cogneesol Agtech Pvt Ltd</strong>&nbsp;and/or its
                    associates, related parties, successors and assigns
                    (collectively hereinafter referred to as&nbsp;
                    <strong>
                      "Provider", &ldquo;us&rdquo;, &ldquo;we&rdquo; or
                      &ldquo;our&rdquo;
                    </strong>
                    .
                  </li>
                  <li>
                    The terms and conditions set below apply to:
                    <ul className="alpha-ul">
                      <li>
                        any persons accessing and downloading the Application (
                        <strong>"Visitor"</strong>); and
                      </li>
                      <li>
                        any persons supplying in any way personal information
                        (including name and email address) to the Provider
                        through or in connection with the Application, whether
                        by way of the Provider's contact form, by email or
                        otherwise ("Registered User"). As part of the
                        registration process you will need to create an account,
                        including a username &amp; password. It is your
                        responsibility to ensure that the information you
                        provide is accurate, not misleading and relates to you.
                        You cannot create an account or username &amp; password
                        using the names and information of another person or
                        using words that are the trademarks or the property of
                        another party (including ours), or vulgar, obscene or in
                        any other way inappropriate. We reserve the right with
                        or without notice to suspend or terminate any account in
                        breach of this condition.
                      </li>
                      <li>
                        If for any reason you suspect that your username &amp;
                        password has been disclosed to or obtained by another
                        party you should contact us immediately. Please note
                        that we never contact users requesting them to confirm
                        their username &amp; password or other details.
                      </li>
                      <li>
                        We would also send messages to the Registered Users for
                        the promotion of the Application and Products available
                        through Application. These messages would be sent
                        from&nbsp;<strong>VM-AKHETI</strong>. The sender&rsquo;s
                        credentials may be changed in future and Registered
                        Users would be apprised accordingly. Though the messages
                        would be promotional in nature for both the Application
                        and Products, still in case the Registered User receive
                        any other kind of messages, then the Registered User can
                        immediately contact us via email&nbsp;&nbsp;
                        <a href="mailto:info@apnikheti.com">
                          info@apnikheti.com
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </ul>
              <p>
                &nbsp;Both categories of users are collectively referred to as
                "Users", "you" or "your" in this T&amp;C.
              </p>
              <ul className="decimal-ul">
                <li>
                  <p>
                    &nbsp;
                    <strong>
                      By becoming a User, you hereby acknowledge and agree to be
                      bound by the T&amp;C.
                    </strong>
                  </p>
                  <p>
                    &nbsp;We may suspend or stop providing the services if you
                    do not comply with our terms and conditions and policies.
                  </p>
                  <p>
                    Using our Application as well as various services provided
                    by us through our Application does not grant you any
                    Intellectual property rights in Our Application and Services
                    or content provided by us except your personal data or
                    information uploaded on our Application.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title">
                ELIGIBILITY FOR REGISTRATION AND ACCOUNT SAFETY
              </h3>
              <ul className="decimal-ul">
                <li>
                  In consideration of your becoming a User, you represent and
                  warrant that:
                  <ul className="alpha-ul">
                    <li>you are 18 years of age or older;</li>
                    <li>you have the capacity to form a binding contract;</li>
                    <li>
                      you are not a person barred from accessing or using the
                      Application under the governing laws of the T&amp;C; and
                    </li>
                    <li>
                      your access or use of the Application does not violate any
                      applicable law or regulation.
                    </li>
                    <li>
                      You will keep your contact information accurate and
                      up-to-date.
                    </li>
                    <li>
                      You will not share your password (or in the case of
                      developers, your secret key), let anyone else access your
                      account, or do anything else that might jeopardize the
                      security of your account.
                    </li>
                    <li>
                      You will not transfer your account (including any Page or
                      application you administer) to anyone without first
                      getting our written permission.
                    </li>
                    <li>
                      If you select a username or similar identifier for your
                      account or Page, we reserve the right to remove or reclaim
                      it if we believe it is appropriate (such as when a
                      trademark owner complains about a username that does not
                      closely relate to a user's actual name).
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">
                PROTECTING OTHER USER&rsquo;S RIGHTS
              </h3>
              <ul className="decimal-ul">
                <li>
                  You will not post any content or take any action on our
                  Application that infringes the rights of the other user or
                  violates any law.
                </li>
                <li>
                  We reserve the right to remove any content or information if
                  we believe that it violates these terms and conditions.
                </li>
                <li>
                  On account of use of any copyright and trademark or you use
                  any logo and trademark which is deceptively similar to the
                  already existing trademarks without our prior written consent,
                  we would disable your account when appropriate.
                </li>
                <li>
                  You are not allowed to post any sensitive financial
                  information or any one&rsquo;s identification.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">
                SHARING OF CONTENT AND INFORMATION
              </h3>
              <ul className="decimal-ul">
                <li>
                  You own all the content and information you post on the
                  Application and you can control how it is shared through your
                  privacy and application settings.
                  <ul className="alpha-ul">
                    <li>
                      For content that is covered by intellectual property
                      rights, like photos and videos (IP content), you
                      specifically grant us, subject to your privacy and
                      application settings, a non-exclusive, transferable,
                      sub-licensable, royalty-free, worldwide license to use,
                      host, store, reproduce, modify, optimize, create
                      derivative works, publish, publicly perform, display and
                      distribute such content in any and all media or
                      distribution methods (now known or later developed).
                    </li>
                    <li>
                      When you delete IP content, it is deleted in a manner
                      similar to emptying the recycle bin on a computer.
                      However, you understand that removed content may persist
                      in backup copies for a reasonable period of time (but will
                      not be available to others).
                    </li>
                    <li>
                      When you use an Application, the Application may ask for
                      your permission to access your content and information as
                      well as content and information that others have shared
                      with you. We require applications to respect your privacy,
                      and your agreement with that application will control how
                      the application can use, store, and transfer that content
                      and information.
                    </li>
                    <li>
                      When you publish content or information using the Public
                      setting, it means that you are allowing everyone to access
                      and use that information, and to associate it with you
                      (i.e., your name and profile picture).
                    </li>
                    <li>
                      You must upload a high quality video and audio message(s)
                      in order to have good results.
                    </li>
                    <li>
                      We hereby disclaim any responsibility regarding the
                      photographs, videos, personal information posted, added,
                      deleted from your profile.
                    </li>
                    <li>
                      Your Content will be viewable by other users of the
                      Service and through third party services and websites. You
                      should only provide Content that you are comfortable
                      sharing with others under these Terms.
                    </li>
                  </ul>
                </li>
                <li>
                  For the purposes of this Clause,&nbsp;
                  <strong>"User Content"</strong>&nbsp;means any and all:
                  <ul className="alpha-ul">
                    <li>
                      any personal information provided by you in a contact form
                      or by way of email (collectively&nbsp;
                      <strong>"Registration Data"</strong>); and
                    </li>
                    <li>
                      any other photographs, videos, audio, data or materials
                      you upload, post, email, transmit or otherwise make
                      available through or in connection with the Application.
                    </li>
                  </ul>
                </li>
                <li>
                  <p>
                    <strong>SAFETY</strong>
                  </p>
                  <p>
                    <strong>
                      You expressly acknowledge, agree and warrant that:
                    </strong>
                  </p>
                  <ul className="alpha-ul">
                    <li>
                      you are solely and entirely responsible for your User
                      Content;
                    </li>
                    <li>
                      all Registration Data which is submitted by you to the
                      Provider through or in connection with the Application is
                      true, accurate and current, and is complete in all
                      respects;
                    </li>
                    <li>
                      you shall update any changes to your Registration Data as
                      soon as practicable; and
                    </li>
                    <li>
                      you shall not upload, post, email, transmit or otherwise
                      make available through or in connection with the
                      Application any User Content that:
                      <ul className="roman-ul">
                        <li>
                          is unlawful, harmful, threatening, abusive, harassing,
                          tortuous, defamatory, pornographic, obscene, libelous,
                          invasive of another's privacy, hateful, or racially,
                          ethnically or otherwise objectionable;
                        </li>
                        <li>
                          you do not have a right to make available under any
                          law or under contractual or fiduciary relationships
                          (such as inside information, proprietary and
                          confidential information learned or disclosed as part
                          of employment relationships or under non-disclosure
                          agreements);
                        </li>
                        <li>
                          infringes any patent, trademark, trade secret,
                          copyright or other proprietary rights of any party;
                        </li>
                        <li>
                          comprises unsolicited or unauthorized advertising,
                          promotional materials, "junk mail," "spam," "chain
                          letters," "pyramid schemes," or any other form of
                          solicitation, except in those areas that are
                          designated for such purpose;
                        </li>
                        <li>
                          contains software viruses, trojan horse, worm, time
                          bomb or any other computer code, files or programs
                          designed to interrupt, destroy or limit the
                          functionality of any computer software or hardware or
                          telecommunications equipment; or
                        </li>
                        <li>
                          purports to impersonate any other person or entity,
                          including, but not limited to, any other User, the
                          Provider's official, employee, consultant, guide, host
                          or any other representative, or falsely state or
                          otherwise misrepresent your affiliation with any
                          person or entity;
                        </li>
                        <li>
                          Attempt to gain unauthorized access to the Application
                          or any networks, servers or computer systems connected
                          to the Application;
                        </li>
                        <li>
                          Modify, adapt, translate or reverse engineer any part
                          of the Application or re-format or frame any portion
                          of the pages comprising the Application, save to the
                          extent expressly permitted by these Terms or by law;
                        </li>
                        <li>
                          You are solely responsible for your conduct and any
                          data, text, files, information, usernames, images,
                          graphics, photos, profiles, audio and video clips,
                          sounds, musical works, works of authorship,
                          applications, links and other content or materials
                          that you submit, post or display on the Application
                          and are also responsible for addition or deletion of
                          any photographs, video and audio clips.
                        </li>
                        <li>
                          You will not use or develop any third party
                          applications that interact with our Application, other
                          user&rsquo;s content or information without legal
                          written consent.
                        </li>
                        <li>
                          You will not use or upload any spider, scraper, virus,
                          robot, crawler or any other automated means to access
                          our Application or extract any other user&rsquo;s data
                          or personal information.
                        </li>
                        <li>
                          you will not solicit login information or access an
                          account belonging to someone else.
                        </li>
                        <li>
                          you will not facilitate or encourage any violations of
                          these terms and conditions.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  You also expressly acknowledge, agree and warrant that the
                  Provider:
                  <ul className="alpha-ul">
                    <li>
                      shall have the right (but not the obligation) in their
                      sole discretion to pre-screen, refuse, or remove any User
                      Content that is made available by you through or in
                      connection with the Application; and
                    </li>
                    <li>
                      may access, preserve, and disclose all User Content if
                      required to do so by law or in a good faith belief that
                      such access preservation or disclosure is reasonably
                      necessary to:
                      <ul className="roman-ul">
                        <li>comply with legal process;</li>
                        <li>enforce the T&amp;C;</li>
                        <li>
                          respond to your requests for customer service; and
                        </li>
                        <li>
                          protect the rights, property, or personal safety of
                          the Website, other Users and/or the public.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  You understand that the technical processing and transmission
                  of all User Content submitted or posted by you may involve:
                  <ul className="alpha-ul">
                    <li>transmissions over various networks; and</li>
                    <li>
                      changes to conform and adapt to technical requirements of
                      connecting networks or devices.
                    </li>
                  </ul>
                </li>
                <li>
                  The Provider does not claim ownership of any User Content you
                  submit or upload through or in connection with the Website.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">PRICING</h3>
              Prices for products are described on our Website and App are
              incorporated into these Terms by reference. All prices are in
              Indian rupees. Prices, products and Services may change at Apni
              Kheti's discretion.
            </li>
            <li>
              <h3 className="small_title my-3">SHIPPING</h3>
              Title and risk of loss for all products ordered by you shall pass
              on to you upon Apni Kheti's shipment to the shipping carrier.
              Rules on COD vary based on transaction value, products, shipping
              location and other relevant parameters. Apni Kheti shall retain
              the right to offer/deny COD for specific cases.
            </li>
            <li>
              <h3 className="small_title my-3">
                EXCLUSION OF LIABILITY AND DISCLAIMER
              </h3>
              <ul className="decimal-ul">
                <li>
                  All Content, whether publicly posted or privately transmitted,
                  is the sole responsibility of the person who originated such
                  Content. We may not monitor or control the Content posted via
                  the Service. Any use of or reliance on any Content or
                  materials posted via the Service or obtained by you through
                  the Service is at your own risk. We do not endorse, support,
                  represent or guarantee the completeness, truthfulness,
                  accuracy, or reliability of any Content or communications
                  posted via the Service or endorse any opinions expressed via
                  the Service. You understand that by using the Service, you may
                  be exposed to Content that might be offensive, harmful,
                  inaccurate or otherwise inappropriate. Under no circumstances
                  will we be liable in any way for any Content, including, but
                  not limited to, any errors or omissions in any Content, or any
                  loss or damage of any kind incurred as a result of the use of
                  any Content made available via the Service or broadcast
                  elsewhere. You are responsible for your use of the Service,
                  for any Content you provide, and for any consequences thereof,
                  including the use of your Content by other users and third
                  party partners. You understand that your Content may be
                  republished and if you do not have the right to submit Content
                  for such use, it may subject you to liability. We will not be
                  responsible or liable for any use of your Content by us in
                  accordance with these Terms.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">WARRANTIES AND DISCLAIMERS&nbsp;</h3>
              <strong>
                We are using a commercially reasonable level of skill and care
                and we hope that our User would enjoy the use of our
                Application. We hereby do not warrant any commitment about the
                content within the services, the specific functions of the
                services, suitability and reliability of the services to your
                specific needs.
                <br />
                <br />
                We exclude all warranties like the implied warranty of
                merchantability, fitness for a particular purpose and
                non-infringement.
                <br />
                <br />
                We hereby disclaims all the warranties, express or implied
                regarding the quality, quantity, merchantability and suitability
                of any product showcased on our application. Any warranties and
                suitability warranties will be that of the manufacturer and/ or
                Vendor.
                <br />
                <br />
                We understand and agree that the Provider, its subsidiaries,
                affiliates, officers, agents, co-branders or other partners and
                employees shall not be liable to you for any direct, indirect,
                incidental, special, consequential or exemplary damages,
                including but not limited to damages for loss or profits,
                goodwill, use, data or other intangible losses, even if the
                Provider has been advised of the possibility of such damages,
                resulting from:
                <br />
                <br />
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;a) Product delivered differs
                from the Product description ordered.
                <br />
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;b) Quality of the product.
                <br />
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;c) Quantity of the product.
                <br />
                <br />
                We hereby disclaims all the warranties, express or implied, to
                protect trademarks and logos whether registered or unregistered,
                and other proprietary rights pertaining to the manufacture of
                the Products of the manufacturers or the Vendor in the Products.
                The Vendor shall be solely liable to abide by the guidelines set
                out in applicable intellectual property laws in general and
                trademark laws of the territory in particular with respect to
                all the Products sold by the Vendor through our Application
                <br />
              </strong>
            </li>
            <li>
              <h3 className="small_title my-3">INDEMNITY</h3>
              <ul className="decimal-ul">
                <li>
                  You agree to fully indemnify, defend and hold the Provider,
                  and its subsidiaries, affiliates, officers, agents,
                  co-branders or other partners, and employees, harmless from
                  any and all claims or demands, liabilities, damages, losses,
                  costs and expenses, including reasonable attorneys' fees, made
                  by any third party due to or arising out of your:
                  <ul className="alpha-ul">
                    <li>
                      access and use of the Application or any Application
                      Contents thereof;
                    </li>
                    <li>violation of the T&amp;C;</li>
                    <li>violation of privacy policy or</li>
                    <li>violation of any rights of another.</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">PRIVACY AND COPYRIGHT</h3>
              <ul className="decimal-ul">
                <li>
                  <p>
                    All copyright in all material contained on, in or available
                    through Application are owned by the Provider or its
                    proprietary holders, and you are required to abide by all
                    copyright notices contained on the Application and Website.
                  </p>
                  <p>
                    Some of the Content, including but not limited to news,
                    views, comments, articles and blogs are published/reproduced
                    of experts and institutions, along with source reference,
                    for information purpose for the Users. We hereby disclaim
                    any liability in case there is any violation of the
                    Proprietary rights or for any loss or damage including
                    without limitation, indirect or consequential loss or
                    damage, or any loss or damage whatsoever arising from loss
                    of data or profits arising out of, or in connection with,
                    the use of this information and website.
                  </p>
                </li>
                <li>
                  Except to the extent otherwise specifically authorised by the
                  Provider and/or the proprietary holders:
                  <ul className="alpha-ul">
                    <li>
                      you may not copy, modify, translate, publicise, reproduce,
                      exploit, broadcast, transmit, distribute, perform, display
                      or sell any of, or any portion of, any or all material ,
                      or create any derivative works thereof, and you may not
                      use any of the material in connection with any commercial
                      endeavours, whether in whole or in part;
                    </li>
                    <li>
                      you may not alter the text, graphics, images, audio visual
                      or any other materials.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>
                    Any unauthorized reproduction, publication, further
                    distribution or public exhibition of the material, in whole
                    or in part, is strictly prohibited.
                  </strong>
                </li>
                <li>
                  In addition, the domain name, the Provider's name, logo, other
                  names and logos of the Provider as may be created, produced or
                  used from time to time (<strong>"Marks"</strong>) are
                  trademarks or registered trademarks of the Provider and its
                  affiliated companies. Without express and written prior
                  permission, you agree not to display or use in any manner the
                  Marks for any purpose whatsoever.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">
                ADVERTISEMENTS AND OTHER COMMERCIAL CONTENT
              </h3>
              <p>
                &nbsp;For the benefit of the user and the advertisers, we use to
                deliver advertising and other commercial or sponsored content.
                The provision of advertising and other commercial or sponsored
                content you shall agree to provide us the permission:
              </p>
              <p>
                To use your name, profile, picture, content, and information
                connection with commercial, sponsored and other related content;
              </p>
              <p>
                We do not give your content to advertiser without your consent.
              </p>
            </li>
            <li>
              <h3 className="small_title">
                MODIFICATIONS TO THE WEBSITE, APPLICATION, WEBSITE CONTENT AND
                T&amp;C
              </h3>
              <ul className="decimal-ul">
                <li>
                  The Provider reserves the right at any time and from time to
                  time to modify or discontinue, temporarily or permanently, the
                  Application or any part thereof, with or without notice to
                  you. You agree that the Provider shall not be liable to you or
                  to any third party for any such modification, suspension or
                  discontinuance of the Application or any part thereof. The
                  most current version of the T&amp;C as posted on this page
                  shall supersede all previous versions.
                </li>
                <li>
                  It is your responsibility to check regularly to determine
                  whether a new version of the T&amp;C has been uploaded. If you
                  do not agree to any revisions pursuant to the upload of a new
                  version of the T&amp;C, then you must immediately stop using
                  the Application.
                </li>
                <li>
                  You agree that the Provider shall not be liable to you or to
                  any third party for any such modification, suspension or
                  discontinuance of the Application, and/or amendments to the
                  T&amp;C. Your continued use of the Application after such
                  modifications or amendments shall constitute an acceptance of
                  your agreement to be bound by the T&amp;C, as amended.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">OFF SITE LINKS</h3>
              <ul className="decimal-ul">
                <li>
                  In order to offer increased value to our Users, the Provider
                  may provide, or third parties may provide, links to other
                  websites or resources, which you may access at your sole
                  discretion.
                </li>
                <li>
                  You understand and acknowledge the Provider has no control
                  over such sites and resources. In this respect, you also
                  acknowledge and agree that the Provider is not responsible for
                  the availability of such external sites or resources, and does
                  not endorse and is not responsible or liable for any content,
                  advertising, products, services or other materials on or
                  available from such sites or resources.
                </li>
                <li>
                  You further acknowledge and agree that the Provider shall not
                  be responsible or liable, directly or indirectly, for any
                  damage or loss caused or alleged to be caused by or in
                  connection with use of or reliance on any such content, goods
                  or services available on or through any such site or resource.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">EMAIL POLICY</h3>
              <ul className="decimal-ul">
                <li>
                  We will not respond unless required to do so by law to any
                  email sent to us which contains threatening, abusive,
                  malicious, pornographic, obscene, defamatory or otherwise
                  illegal or inappropriate material. We reserve the right to
                  take such action as we in our sole discretion deem fit in
                  respect of such material.
                </li>
                <li>
                  We will not disclose any personal information under any
                  circumstances of any staff, employee, contractor or worker of
                  the Provider and/or the Provider's associates. Where
                  appropriate we will endeavour to respond to all Emails within
                  2 days of receipt, but we cannot and do not guarantee to
                  respond to any Emails. All Emails will generally be stored for
                  2 month after which time they will automatically be deleted.
                  Any Email sent to the incorrect destination is liable to be
                  deleted immediately.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">PRIVACY POLICY</h3>
              <p>
                The use of any personal information collected from you is
                subject to our Privacy Policy, which is incorporated into this
                T&amp;C by reference.
              </p>
            </li>
            <li>
              <h3 className="small_title">NO THIRD PARTY BENEFICIARIES</h3>
              <p>
                &nbsp;You agree that, except as otherwise expressly provided in
                this T&amp;C, there shall be no third party beneficiaries to
                this T&amp;C, and that you may not assign your profile or
                registration to any other persons.
              </p>
            </li>
            <li>
              <h3 className="small_title">NOTICES</h3>
              <p>
                If you choose to provide us with a nominated email address,
                unless you expressly inform us otherwise, the Provider may
                communicate with you by providing you with notices regarding
                updates, changes or additions to the Application or Services
                offered through or in connection with the Application.
              </p>
            </li>
            <li>
              <h3 className="small_title">GOVERNING LAW</h3>
              <ul className="decimal-ul">
                <li>
                  This T&amp;C and any obligations arising out of or in relation
                  to the T&amp;C shall be governed by and construed in
                  accordance with the laws of&nbsp;<strong>INDIA</strong>.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">JURISDICTION</h3>
              <p>
                You understand, agree and acknowledge that the&nbsp;
                <strong>Courts of SAS Nagar, Mohali</strong>&nbsp;are to have
                exclusive jurisdiction to settle any dispute (including claims
                for set-off and counterclaims and disputes relating to any
                non-contractual obligations) which may arise out of or in
                connection with the T&amp;C and for such purposes irrevocably
                submit to the jurisdiction of the aforesaid Courts.
              </p>
            </li>
            <li>
              <h3 className="small_title">ENTIRE AGREEMENT</h3>
              <ul className="decimal-ul">
                <li>
                  The T&amp;C constitute the entire agreement between you and
                  the Provider and govern your access and use of, or purchase
                  through or in connection with the Application, superseding any
                  prior agreements between you and the Provider.
                </li>
                <li>
                  You also may be subject to additional terms and conditions
                  that may apply when you use or purchase certain other services
                  of the Provider, affiliated services, third-party content or
                  third-party software.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">WAIVER AND SEVERABILITY OF TERMS</h3>
              <ul className="decimal-ul">
                <li>
                  The failure of the Provider to exercise or enforce any right
                  or provision of the T&amp;C shall not constitute a waiver of
                  such right or provision.
                </li>
                <li>
                  If any provision of the T&amp;C is found by a Court of
                  competent jurisdiction to be invalid, the parties nevertheless
                  agree that the Court should endeavour to give effect to the
                  parties' intentions as reflected in the provision, and the
                  other provisions of the T&amp;C remain in full force and
                  effect.
                </li>
              </ul>
            </li>
            <li>
              <h3 className="small_title my-3">VIOLATIONS AND INFRINGEMENTS</h3>
              <p>
                Any violations or infringement of the T&amp;C should promptly be
                reported by the User by emailing the Provider at&nbsp;
                <a href="mailto:info@apnikheti.com" target="_blank" rel="noopener noreferrer">info@apnikheti.com</a>
              </p>
            </li>
          </ul>
          <p style={{ "textAlign": "justify" }}>&nbsp;</p>
        </div>

        <div className="modal-footer p-0 pt-3">
          <button
            type="button"
            className="btn btn-light-primary font-weight-bold"
            data-dismiss="modal"
            onClick={() => {
              setTerms(false);
            }}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary font-weight-bold"
            data-dismiss="modal"
            onClick={() => {
              setTerms(true);
            }}
          >
            I agree
          </button>
        </div>
      </ModalWrapper>
    </>
  );
};

export default ConditionsModal;
